
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import {homePageWatcher} from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({
  name: "GeographyCargoTransportationBlock",

  components: {
    Map: () => import("./components/GeographyCargoTransportationBlock/Map")
  },

  computed: {
    classNameRoot: function () {
      let _classes = [];
      if (this.cfgs?.theme) {
        _classes.push(this.cfgs?.theme);
      }
      if (this.isHome) {
        _classes.push('padding-home');
      }

      return _classes.join(" ")
    },
    isHome: function() {
      return homePageWatcher(this.$route.fullPath);
    },
  },

  methods: {
    onOrderTransportation: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: "Рассчитать стоимость",
          miniReachGoal: "calculate_the_cost_callback_small_form",
          fullReachGoal: "calculate_the_cost_get_transportation_calculation_large_form",
        }
      });
    }
  }
});
